import { DateOption } from 'modules/jogador/booking/types';

interface DateSelectorProps {
  dates: DateOption[];
  selectedDateId: string;
  onSelect: (dateId: string) => void;
}

export function DateSelector({ dates, selectedDateId, onSelect }: DateSelectorProps) {
  return (
    <div className="flex gap-2">
      {dates.map((date) => {
        const isSelected = date.id === selectedDateId;

        return (
          <button
            key={date.id}
            type="button"
            onClick={() => onSelect(date.id)}
            className={`flex flex-1 flex-col items-center rounded-xl px-3 py-2 text-sm transition-colors ${
              isSelected ? 'bg-primary text-surface' : 'bg-chip text-ink-secondary hover:bg-accent-soft'
            }`}
          >
            <span className="text-xs uppercase">{date.weekday}</span>
            <span className="font-semibold">{date.day}</span>
          </button>
        );
      })}
    </div>
  );
}
